import React, { FC } from 'react';
import styles from './results_card.module.scss';

export const SearchCard: FC = props => (
  <div className={styles.searchCard} {...props} />
);

export const FollowContainer: FC = props => (
  <div className={styles.followContainer} {...props} />
);

export const SearchCardTitle: FC = props => (
  <div className={styles.title} {...props} />
);

export const SearchCardFooter: FC = props => (
  <div className={styles.footer} {...props} />
);
export const SearchCardList: FC = props => (
  <div className={styles.list} {...props} />
);
